import { useQuery } from "@tanstack/react-query";
import { getTransactionFeesHunterCardEarnings } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEES_HUNTER_CARD_EARNINGS_QUERY_KEY =
  "TRANSACTIONS_FEES_HUNTER_CARD_EARNINGS";

export const getTransactionsFeesHunterCardEarningsQueryKey = () => [
  TRANSACTIONS_FEES_HUNTER_CARD_EARNINGS_QUERY_KEY,
];

export const useTransactionsFeesHunterCardEarnings = () =>
  useQuery({
    queryKey: getTransactionsFeesHunterCardEarningsQueryKey(),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionFeesHunterCardEarnings(),
    ),
  });
